import React, { Component } from 'react';

import ConfigForm from './components/ConfigForm/ConfigForm';
import './ConfigPage.scss';

export default class ConfigPage extends Component {
    render() {
        return (
            <div className="ConfigPage">
	            <h2>Config</h2>
	            <ConfigForm/>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/ConfigPage/ConfigPage.js